/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PutApiNotificationsIdMutationRequest, PutApiNotificationsIdMutationResponse, PutApiNotificationsIdPathParams, PutApiNotificationsId400, PutApiNotificationsId401, PutApiNotificationsId403, PutApiNotificationsId404, PutApiNotificationsId500 } from "../../types/PutApiNotificationsId.ts";
import { putApiNotificationsIdMutationResponseSchema, putApiNotificationsIdMutationRequestSchema } from "../../zod/NotificationSchemas/putApiNotificationsIdSchema.ts";

function getPutApiNotificationsIdUrl({ id }: { id: PutApiNotificationsIdPathParams["Id"] }) {
  const res = { method: 'PUT', url: `/api/notifications/${id}` as const }  
  return res
}

/**
 * @summary Редактирование PUSH уведомления по идентификатору
 * {@link /api/notifications/:Id}
 */
export async function putApiNotificationsId({ id, data }: { id: PutApiNotificationsIdPathParams["Id"]; data?: PutApiNotificationsIdMutationRequest }, config: Partial<RequestConfig<PutApiNotificationsIdMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = putApiNotificationsIdMutationRequestSchema.parse(data)  
  
  const res = await request<PutApiNotificationsIdMutationResponse, ResponseErrorConfig<PutApiNotificationsId400 | PutApiNotificationsId401 | PutApiNotificationsId403 | PutApiNotificationsId404 | PutApiNotificationsId500>, PutApiNotificationsIdMutationRequest>({ method : "PUT", url : getPutApiNotificationsIdUrl({ id }).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return putApiNotificationsIdMutationResponseSchema.parse(res.data)
}